export default __webpack_public_path__ + "static/media/sushi.6abf7820.png";